import { useState, ReactNode } from 'react';
import { Alert, Snackbar, Slide, SlideProps } from '@mui/material';
import { AlertProps, AlertServiceContext } from "./types";

export function AlertProvider({ children }: { children: ReactNode }) {
    const [alerts, setAlerts] = useState<AlertProps[]>([]);

    function showAlert(alert: AlertProps) {
        setAlerts((prevAlerts) => [...prevAlerts, alert]);
    }

    function removeAlert(index: number) {
        setAlerts((prevAlerts) => prevAlerts.filter((_, i) => i !== index));
    }

    return (
        <AlertServiceContext.Provider value={{ showAlert }}>
            {children}
            {alerts.map((alert, index) => (
                <Snackbar
                    key={index}
                    open
                    anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                    autoHideDuration={alert.duration || 2000}
                    onClose={() => removeAlert(index)}
                    TransitionComponent={(props: SlideProps) => <Slide {...props} direction="left" />}
                    sx={{
                        '&.MuiSnackbar-root': {
                            marginTop: '50px',
                        },
                    }}
                >
                    <Alert
                        severity={alert.type}
                        variant="filled"
                        onClose={() => removeAlert(index)}
                    >
                        {alert.message}
                    </Alert>
                </Snackbar>
            ))}
        </AlertServiceContext.Provider>
    );
}